import DataGrid from 'react-data-grid';
import NoRecords from 'components/ui/DataGrid/NoRecords';

const DataTableWidget = ({ data = [], settings }) => {
  return (
    <DataGrid
      className="data-grid rdg-light"
      cellNavigationMode={true}
      {...settings}
      rows={data || []}
      rowName="row"
      rowHeight={60}
      emptyRowsRenderer={NoRecords}
    />
  );
};

export default DataTableWidget;
